
export const parseHash = () => {
  if (window.location.hash.length <= 1) {
    return {}
  }
  let parameters = {}
  let pairs = window.location.hash.substring(1).split('&')
  for (let i = 0; i < pairs.length; i++) {
    let kv = pairs[i].split('=')
    if (kv.length > 1) {
      parameters[kv[0]] = kv[1]
    } else {
      parameters[kv[0]] = kv[0]
    }
  }
  return parameters
}



// WEBPACK FOOTER //
// ./src/Url.js